/*
 * @Description: 绩效审批
 * @Author: 杨志航
 * @Date: 2026-01-19 14:07:23
 */
import React, { useState, useEffect } from 'react'
import api from 'api'
import {
  Table,
  Alert,
  Form,
  Drawer,
  DatePicker,
  Input,
  Button,
  message,
  Switch,
  Select,
  Popconfirm,
} from 'antd'
import Auth from '@/components/AuthMiddleware'
import { allTrim, filterParams, cryptoParamsIntoUrl } from '@/utils'
import AuditNode from '../module/AuditNode'
import { Link } from 'react-router-dom'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const { MonthPicker, RangePicker } = DatePicker
const dateFormatMonth = 'YYYY-MM'
const dateFormat = 'YYYY-MM-DD'
const auditTypeList = [{
  id: 1,
  name: '绩效目标'
}, {
  id: 2,
  name: '绩效结果'
}]

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage
}

const Main = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const { match } = props
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [authList, setAuthList] = useState([])//按钮权限
  const [auditStatusList, setAuditStatusList] = useState([]) // 审批状态
  const [departList, setDepartList] = useState([])
  const [groupList, setGroupList] = useState([])
  const [auditNodeVisible, setAuditNodeVisible] = useState(false)
  const [shouldMe, setShouldMe] = useState(false)

  useEffect(() => {
    resetParams()
    getList()
    getPageAuth()
    getSearchData()
    getAuditStatusList()
  }, [])
  //按钮权限
  const getPageAuth = () => {
    api.getPageAuth().then(list => {
      setAuthList(list)
    })
  }

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getApprovalList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    setShouldMe(false)
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.month) {
          vals.month = vals.month.format(dateFormatMonth)
        }
        if (vals.addTime && vals.addTime.length === 2) {
          vals.addTimeMin = vals.addTime[0].format(dateFormat)
          vals.addTimeMax = vals.addTime[1].format(dateFormat)
        }
        delete vals.addTime
        const { shouldMe } = searchParams
        if (shouldMe) {
          vals.shouldMe = shouldMe
        }
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }

  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  //获取检索所需数据
  const getSearchData =  () => {
    api.getSearchData().then(res => {
      const { groupList, departList } = res
      setDepartList(departList)
      setGroupList(groupList)
    })
  }

  // 审批状态
  const getAuditStatusList = () => {
    api.getAuditStatusList({ type: 54 }).then(data => {
      setAuditStatusList(data)
    })
  }

  const onSetShouldMe = checked => {
    setShouldMe(checked)
    if (checked) {
      searchParams.shouldMe = 1
    } else {
      delete searchParams.shouldMe
    }
    getList()
  }

  const handleAuditNode = () => {
    setAuditNodeVisible(true)
  }

  const handleDel = id => {
    setLoading(true)
    api.delAchAudit({
      id
    }).then(() => {
      message.success('删除成功')
      getList()
    }).catch(() => { setLoading(false) })
  }

  const handlePreview = id => {
    api.getHost().then((res) => {
      window.open(`${res.url}/api/fortune/achievements/Preview?id=${id}&type=2`, '_blank')
    })
  }

  return <>
    <div className="search-doc-wrap">
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <div className="form-box">
          <FormItem label="业务编号">
            {getFieldDecorator('businessNo')(<Input placeholder="请输入业务编号" />)}
          </FormItem>
          <FormItem label="申请类型">
            {getFieldDecorator('auditType')(<Select 
              placeholder="请选择申请类型"
              allowClear
            >
              {
                auditTypeList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="审批状态">
            {getFieldDecorator('auditStatus')(<Select 
              placeholder="请选择审批状态"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                auditStatusList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="绩效月份">
            {getFieldDecorator('month')(<MonthPicker placeholder="请选择月份" />)}
          </FormItem>
          <FormItem label="申请人">
            {getFieldDecorator('applyStfName')(<Input placeholder="请输入申请人" />)}
          </FormItem>
          <FormItem label="所属部门">
            {getFieldDecorator('departmentId')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                departList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="所属事业群">
            {getFieldDecorator('groupId')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                groupList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="申请日期">
            {getFieldDecorator('addTime')(<RangePicker
              placeholder={['开始日期', '结束日期']}
            />)}
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Switch 
            checkedChildren="待审批" 
            unCheckedChildren="待审批" 
            disabled={loading} 
            onChange={onSetShouldMe} 
            className="shouldme-switch-btn" 
            checked={shouldMe}
          />
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <div className="add-wrap">
        <Auth auths={authList} code="audit-node-set">
          <Button type="primary" onClick={handleAuditNode}>审批节点配置</Button>
        </Auth>
      </div>
      <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey="id"  
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
      >
        <Column title="业务编号" dataIndex="businessNo" />
        <Column title="申请类型" dataIndex="auditTypeName" />
        <Column title="绩效月份" dataIndex="month" />
        <Column title="申请人" dataIndex="staffName" />     
        <Column title="员工编号" dataIndex="staffNo" />
        <Column title="职位" dataIndex="jobPositionName" />
        <Column title="所属部门" dataIndex="departmentName" />
        <Column title="所属事业群" dataIndex="groupName" />
        <Column title="部门总监" dataIndex="departmentLeaderName" />
        <Column title="直接领导" dataIndex="leaderName" />
        <Column title="申请人数" dataIndex="num" />
        <Column title="申请时间" dataIndex="addTime" />
        <Column title="审批时间" dataIndex="auditTime" />
        <Column title="审批状态" dataIndex="auditStatusName" />
        <Column 
          title="操作"
          key="set" 
          align="center"
          width={100}
          render={record =>
            <>
              <Link to={cryptoParamsIntoUrl(`${match.path}/detail`, { id: record.id, })}>
                查看
              </Link>
              {record.allowDelete && (
                <Popconfirm 
                  title="请确认是否删除?" 
                  onConfirm={() => handleDel(record.id)}
                >
                  <a style={{ marginLeft: '10px' }}>删除</a>
                </Popconfirm>
              )}
              {record.auditStatus === 4 && (
                <div>
                  <a onClick={() => handlePreview(record.id)}>打印预览</a>
                </div>
              )}
            </>
          }
        />
      </Table>
    </div>
    <Drawer
      title="绩效审批节点配置"
      width={900}
      onClose={() => setAuditNodeVisible(false)}
      visible={auditNodeVisible}
      destroyOnClose={true}
    >
      <AuditNode 
        departList={departList}
        groupList={groupList}
      />
    </Drawer>
  </>
}

export default Form.create()(Main)
